import BaseModel from 'src/model/base.model';

class CreditCardInfoModel extends BaseModel {
  public cardToken: string;
  public cardType: string;
  public city: string;
  public customerNumber: string;
  public expirationDate: string;
  public holderAddress1: string;
  public holderAddress2: string;
  public holderCountry: string;
  public holderName: string;
  public holderState: string;
  public holderZipCode: string;
  public userId: string;
}

export default CreditCardInfoModel;
